import { useCallback } from 'react'

import {
  AlertType,
  useNotifications
} from '@app/common/services/Notifications/NotificationsProvider'
import { CourtCaseMessageInput } from '@app/graphql/types'
import { useUpsertCourtCaseMessageMutation } from '@app/modules/CourtCases/Components/ChatChronic/queries/UpsertCourtCaseMessage.queries'

export const useUpsertCourtCaseMessage = () => {
  const { pushNotification } = useNotifications()

  const [upsertCourtCaseMutation, { loading: upsertingMessage }] =
    useUpsertCourtCaseMessageMutation({
      onError: (error) => {
        pushNotification({
          type: AlertType.error,
          message: error.message
        })
      }
    })

  const upsertMessage = useCallback(
    async (input: CourtCaseMessageInput) => {
      const result = await upsertCourtCaseMutation({
        variables: {
          input: {
            ...input
          }
        }
      })
      return result.data?.upsertCourtCaseMessage
    },
    [upsertCourtCaseMutation]
  )

  return {
    upsertMessage,
    upsertMessageLoading: upsertingMessage
  }
}
